import React from "react";
import ReactApexChart from 'react-apexcharts';

const HistoryChart = (props) => {

    const series = [{
        name: `${props.coinName}`,
        data: props.coinHistory.map((el) => {
            return {
                x: el.x,
                y: (el.y / props.trxPrice).toFixed(2)
            }
        })
    }]

    const options = {
        chart: {
            zoom: {
                enabled: false,
            },
            toolbar: {
                show: false,
            },
            height: 245,
            type: 'area'
        },
        colors: ['#ffb628'],
        grid: {
            show: false,
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'smooth'
        },
        xaxis: {
            tooltip: {
                enabled: false
            },
            type: 'datetime',
            labels: {
                show: false,
                formatter: function (value, timestamp) {
                    return new Date(timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
                },
            }
        },
        yaxis: {
            show: false,
            labels: {
                formatter: function (val, index) {
                    return val.toFixed(2) + " CHY";
                }
            }
        },
        tooltip: {
            x: {
                format: 'dd/MM/yy HH:mm'
            },
        },
    }

    return (
        <>
            <ReactApexChart options={options} series={series} type="area" height={245} />
        </>
    )

}

export default HistoryChart;